import { defineStore } from "pinia";

import { $api } from "@/services/api1";
import {
  StipulationVM,
  StipulationType,
  StipulationTabVM,
  SectionVM,
} from "@/types/stipulation";
import { BaseOption, LOSType } from "@/types/types";

export const useStipulationStore = defineStore("stipulationStore", {
  state: () => {
    return {
      stipulationTabVM: {} as StipulationTabVM,
      showAddStipsButton: false,
    };
  },

  getters: {
    Stips(state): StipulationVM[] {
      if (state.stipulationTabVM.stipulations?.length > 0)
        return state.stipulationTabVM.stipulations;
      return [];
    },
    Sections(state): SectionVM[] {
      return state.stipulationTabVM?.sections || [];
    },
    StipulationTypes(state): StipulationType[] {
      return state.stipulationTabVM?.stipulationModal?.stipulationTypes || [];
    },
    GoodThruDate(state): string {
      return state.stipulationTabVM?.goodThruDate;
    },
    RefiLoan(state) {
      return (refiLoanId: number) => {
        return state.stipulationTabVM?.stipulationModal?.payOffLoans.find(
          (pl) => pl.refiLoanId == refiLoanId
        );
      };
    },
    LoansOptions(state): BaseOption[] {
      return state.stipulationTabVM?.stipulationModal?.payOffLoans?.length > 0
        ? state.stipulationTabVM.stipulationModal.payOffLoans.map(
            (payoffLoan) => ({
              label: payoffLoan.accountNumber,
              value: payoffLoan.refiLoanId,
            })
          )
        : [];
    },
  },

  actions: {
    setAddStipButton(applicationStatusId: number) {
      this.showAddStipsButton =
        applicationStatusId == 2 || applicationStatusId == 3;
    },
    updateStipulation(newObj: StipulationVM) {
      const objWithIdIndex = this.stipulationTabVM.stipulations.findIndex(
        (obj) => obj.id === newObj.id
      );
      if (objWithIdIndex > -1) {
        this.stipulationTabVM.stipulations[objWithIdIndex] = Object.assign(
          {} as StipulationVM,
          newObj
        );
      }
    },
    updateStipulations(stips: StipulationVM[]) {
      this.stipulationTabVM.stipulations = stips;
    },
    async getStipulations(applicationId: number) {
      try {
        const response = await $api.applications.getApplicationStipulationList(
          applicationId
        );

        if (response?.results) {
          this.stipulationTabVM = response.results;
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
});
